<template>
  <div>
    <p>
      <strong
        >{{ nomeSaleChannel }} - Plataforma Para Gestão de Recebíveis!</strong
      >
    </p>
    <p>&copy; {{ year }} {{ nomeSaleChannel }} &copy;</p>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

const NOME_BASE = "Acquire Solutions";
const DESCRICAO = "Acquire - Plataforma Para Gestão de Recebíveis!";
export default {
  name: "AcquireCopyright",
  computed: {
    ...mapGetters({
      getConfig: "getConfig"
    }),
    year() {
      return new Date().getFullYear();
    },
    nomeSaleChannel() {
      try {
        return this.getConfig.name || NOME_BASE;
      } catch (e) {
        return NOME_BASE;
      }
    }
  }
};
</script>

<style lang="scss" module>
@use './style.module.scss' as style;
</style>
